import { configureStore } from '@reduxjs/toolkit';
import { playerSlice } from '../components/player/playerSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { playerUISlice } from '../components/player/playerUISlice';
import { epgDetailsSlice } from '../components/epg/EpgDetailsModal/epgDetailsSlice.ts';
import { epgPageSlice } from '../components/epg/epgPageSlice.ts';
import { modalsStateSlice } from '../components/popups/modalsStateSlice.ts';
import { authSlice } from '../components/auth/authSlice.ts';
import { accountFavoritesSlice } from '../components/account/favorite/accountFavoritesSlice.ts';
import { accountNotificationsSlice } from '../components/account/notification/accountNotificationsSlice.ts';
import { accountRemindersSlice } from '../components/account/reminder/accountRemindersSlice.ts';

export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        epgDetails: epgDetailsSlice.reducer,
        epgPage: epgPageSlice.reducer,
        favorites: accountFavoritesSlice.reducer,
        player: playerSlice.reducer,
        playerUI: playerUISlice.reducer,
        reminders: accountRemindersSlice.reducer,
        modalsState: modalsStateSlice.reducer,
        notifications: accountNotificationsSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['player/change-video/rejected'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
